import { oCurrencyFormatter } from 'utils/common';

/**
 * Formats the fund financial data into a list of data points for the chart.
 *
 * @param {object} oData - Fund financial data.
 * @returns {array}
 */
export const fnFormatChartData = (oData) => {
  let aChartData = [];
  if (oData.VALUE_OVER_TIME.length === 0) {
    // The fund only has annual start/end financial data
    aChartData = [
      {
        name: 'Start',
        value: parseFloat(oData.FISCAL_YEAR_BEGINNING_VALUE),
      },
      {
        name: 'End',
        value: parseFloat(oData.FISCAL_YEAR_ENDING_VALUE),
      },
    ];
  } else {
    // The fund has quarterly financial data
    aChartData = oData.VALUE_OVER_TIME.map(({ INTERVAL, ENDING_VALUE }) => ({
      name: INTERVAL,
      value: parseFloat(ENDING_VALUE),
    })).reverse();
  }
  return aChartData;
};

export const oTooltipContentStyle = {
  borderColor: 'gray',
  borderWidth: '2px',
  borderRadius: '12px',
  backgroundColor: 'white',
  padding: '1.6rem',
};

export const oTooltipItemStyle = {
  color: '#1b1b1b',
  fontFamily: 'Roboto, sans-serif',
  fontSize: '1.6rem',
};

export const fnFormatTooltipValue = (nRawValue) => {
  const sFormattedAmount = oCurrencyFormatter.format(nRawValue);
  return [sFormattedAmount, 'Value'];
};

export const fnFormatTooltipLabel = (sLabel) => {
  let sFormattedLabel = '';
  switch (sLabel) {
    case 'Q1':
      sFormattedLabel = 'Sept. 30 (unaudited)';
      break;
    case 'Q2':
      sFormattedLabel = 'Dec. 31 (unaudited)';
      break;
    case 'Q3':
      sFormattedLabel = 'Mar. 31 (unaudited)';
      break;
    case 'Q4':
      sFormattedLabel = 'Jun. 30 (audited)';
      break;
    case 'Start':
      sFormattedLabel = 'Jul. 1';
      break;
    case 'End':
      sFormattedLabel = 'Jun. 30';
      break;
    default:
      break;
  }
  return sFormattedLabel;
};
